export class EpsSpotType {
    spot_type_id: number;
    spot_short_desc: string;
    spot_desc: string;
    spot_type_code: string;
}